import Image from 'next/image'
import _ from 'lodash'
import { useRouter } from 'next/navigation'
import { HomeIcon } from '@heroicons/react/24/outline'

interface MenubarHeaderProps {
  logoImg: string | undefined
}

const MenubarHeader = ({ logoImg }: MenubarHeaderProps) => {
  const router = useRouter()

  const goToCourses = () => {
    router.push('/courses')
  }

  return (
    <div className="flex w-full flex-row items-center justify-between bg-white">
      {logoImg && (
        <div className="flex w-full px-4 py-2 lg:items-center lg:justify-center lg:border-b lg:px-0 lg:pb-3 lg:pt-0">
          <div
            className="relative h-[48px] cursor-pointer lg:h-auto lg:w-[132px]"
            onClick={goToCourses}
          >
            <Image
              src={logoImg}
              alt="기업 로고"
              width={260}
              height={100}
              objectFit="cover"
              className="h-full w-full"
            />
          </div>
        </div>
      )}
      <div className="relative flex items-center px-4 py-5 lg:hidden">
        <button className="cursor-pointer" onClick={goToCourses}>
          <HomeIcon className="h-6 w-6 text-label-alternative" />
        </button>
      </div>
    </div>
  )
}

export default MenubarHeader
